/**
 * Built-in virtual-background presets. Images are bundled in
 * `frontend/public/backgrounds/` so they load same-origin (no CORS canvas
 * tainting when the WebGL virtual-background processor samples them).
 */
export const BACKGROUND_PRESETS = [
  { id: "office", label: "Office", src: "/backgrounds/office.jpg" },
  { id: "bookshelf", label: "Bookshelf", src: "/backgrounds/bookshelf.jpg" },
  { id: "plants", label: "Greenery", src: "/backgrounds/plants.jpg" },
  { id: "warm", label: "Warm", src: "/backgrounds/warm.jpg" },
  { id: "teal", label: "Brand teal", src: "/backgrounds/teal.jpg" },
  { id: "studio", label: "Studio grey", src: "/backgrounds/studio.jpg" },
];

export function resolvePresetSrc(id) {
  const p = BACKGROUND_PRESETS.find((x) => x.id === id);
  return p ? p.src : null;
}
